export interface IProvider {
  id: number;
  name: string;
  label: string;
  practice_id:number;
  practice_name:string;
  provider_first_name:string;
  provider_last_name:string;
  npi: string;
  tin: number;
}

export class Provider {
  id: number;
  name: string;
  npi: string;
  label: string;
  practiceId:number;
  practiceName:string;
  providerFirstName:string;
  providerLastName:string;
  providerFullName:string;
  tin:number;

  constructor(data?: IProvider) {
    this.id = data?.id ?? 0;
    this.name = data?.name ?? '';
    this.label = data?.name ?? '';
    this.npi = data?.npi ?? '';
    this.practiceId = data?.practice_id ?? 0;
    this.practiceName = data?.practice_name ?? '';
    this.providerFirstName = data?.provider_first_name ?? '';
    this.providerLastName = data?.provider_last_name ?? '';
    this.providerFullName =this.providerFirstName + ' ' + this.providerLastName;
    this.tin = data?.tin ?? 0;
  }

  static fromObjectArray(providers: IProvider[]): Provider[] {
    return providers.map(provider => new Provider(provider));
  }
}

export interface IResultProvider {
  count: number;
  next: string;
  previous: string;
  results: IProvider[];
}

export class ResultProvider {
  count: number = 0;
  next: string = '';
  previous: string = '';
  results: Provider[] = [];

  constructor(result?: IResultProvider) {
    if (result) {
      this.count = result.count ?? 0;
      this.next = result.next ?? '';
      this.previous = result.previous ?? '';
      this.results = Provider.fromObjectArray(result.results ?? []);
    }
  }
}
